import React, { useEffect, useState, useRef } from "react";
import "./DarkModeButton.css";

export default function DarkModeButton() {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("theme") === "dark");
  const [ripple, setRipple] = useState(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const body = document.body;
    const bg = document.querySelector('.bg_app');
    // Toggle dark mode class on the body; .bg_app CSS handles the image
    if (darkMode) {
      body.classList.add("dark-mode");
      if (bg) bg.classList.add("dark-mode");
      localStorage.setItem("theme", "dark");
    } else {
      body.classList.remove("dark-mode");
      if (bg) bg.classList.remove("dark-mode");
      localStorage.setItem("theme", "light");
    }

  }, [darkMode]);

  const handleClick = (e) => {
    setDarkMode((prev) => !prev);
    const button = buttonRef.current;
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;
    setRipple({ x, y, size });
    setTimeout(() => setRipple(null), 500);
  };

  return (
    <button className="theme-toggle" onClick={handleClick} ref={buttonRef}>
      {ripple && (
        <span
          className="ripple"
          style={{
            left: ripple.x,
            top: ripple.y,
            width: ripple.size,
            height: ripple.size,
          }}
        />
      )}
      <span className="theme-toggle-icon" aria-label={darkMode ? "Világos mód" : "Sötét mód"}>
        {darkMode ? "☀️ " : "🌙 "}
      </span>
      <span className="theme-toggle-text">{darkMode ? "Világos mód" : "Sötét mód"}</span>
    </button>
  );
}